<template>
    <div style="display: flex; flex-direction: column">
        <div style="display: flex">
            <h2>Insertion orders</h2>
        </div>

        <div>
            <div class="filter-group list-filter" style="display: flex; flex-wrap: wrap;">
                <div class="form-group">
                    <label>Agency</label>
                    <el-input v-model="filter.agency_name" v-on:keyup.enter="refresh" />
                </div>
                <div class="form-group">
                    <label>Client / Division</label>
                    <el-input v-model="filter.client" />
                </div>
                <div class="form-group">
                    <label>IO Number</label>
                    <el-input v-model="filter.io_number" />
                </div>
                <div class="form-group">
                    <label>Order Period</label>
                    <el-date-picker
                        v-model="filter.order_period_from"
                        type="month"
                        format="MMM yyyy"
                        value-format="yyyy-MM-dd"
                        placeholder="From"
                        style="width: 100%"
                    >
                    </el-date-picker>
                </div>
                <div class="form-group">
                    <label>&nbsp;</label>
                    <el-date-picker
                        v-model="filter.order_period_to"
                        type="month"
                        format="MMM yyyy"
                        value-format="yyyy-MM-dd"
                        placeholder="To"
                        style="width: 100%"
                    >
                    </el-date-picker>
                </div>
                <div class="form-group">
                    <label>Received on</label>
                    <el-date-picker
                        v-model="filter.received_from"
                        type="date"
                        format="M/d/yyyy"
                        value-format="yyyy-MM-dd"
                        placeholder="From"
                        style="width: 100%"
                    >
                    </el-date-picker>
                </div>
                <div class="form-group">
                    <label>&nbsp;</label>
                    <el-date-picker
                        v-model="filter.received_to"
                        type="date"
                        format="M/d/yyyy"
                        value-format="yyyy-MM-dd"
                        placeholder="To"
                        style="width: 100%"
                    >
                    </el-date-picker>
                </div>
                <div class="form-group">
                    <label>States</label>
                    <el-select
                        v-model="filter.io_states"
                        multiple
                        collapse-tags
                        placeholder="Select"
                        style="width: 100%"
                    >
                        <el-option
                            v-for="item in lists.io_states"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </div>
                <div class="form-group" style="padding-top: 25px">
                    <btn cssClass="btn btn-secondary" icon="fas fa-redo-alt" :click="refresh">Filter</btn>
                </div>
            </div>
        </div>

        <table class="table table-striped table-hover table-sticky-header custom-table" v-loading="loading">
            <thead>
                <tr>
                    <th></th>
                    <th>
                        From / Agency
                    </th>
                    <th>
                        IO Client / Division
                    </th>
                    <th>
                        IO Number
                    </th>
                    <th>
                        Period
                    </th>
                    <th style="text-align: right; padding-right: 8px">Total Net</th>
                    <th>
                        State
                    </th>
                    <th>Date Received</th>
                </tr>
            </thead>
            <insertion-order-list-row :row="row" v-for="row in rows" :key="row.id" @refresh="refresh" />
        </table>
        
        <div class="row" v-if="pagination.total > 0">
            <div class="col-sm-12 text-center">
                <el-pagination 
                    layout="prev, pager, next"
                    background
                    v-bind:current-page.sync="pagination.page"
                    @current-change="changePage"
                    :page-size="pagination.perPage"
                    :total="pagination.total"
                />
            </div>
        </div>
    </div>
</template>

<script>
import InsertionOrderListRow from "./insertion-order-list-row";

export default {
    components: {
        InsertionOrderListRow
    },
    data() {
        return {
            filter: {
                agency_name: '',
                client: '',
                io_number: '',
                order_period_from: null,
                order_period_to: null,
                received_from: null,
                received_to: null,
                io_states: [
                    // "Unprocessed"
                ]
            },
            rows: [],
            pagination: {
                page: 1,
                perPage: 25,
                total: 0
            },
            lists: {
                io_states: [],
            },
            loading: true
        };
    },
    methods: {
        refresh() {
            this.loading = true;

            return axios.post(url(`admin/insertion-orders/list/data`), this.filter)
                .then((response) => {
                    this.rows = response.data.rows;
                    this.pagination = response.data.pagination;
                    this.lists = response.data.lists;
                    this.loading = false;
                });
        },
        changePage(page) {
            this.filter.page = page;
            this.refresh();
        },
    },
    mounted() {
        this.refresh();
    }
}
</script>